import { useMutation } from "@apollo/client";

import { SetActiveRoleMutation } from "../../../graphql/deliveryService/mutations/setActiveRole";

const useSetActiveRoleMutation = () => {
  return useMutation(SetActiveRoleMutation, {});
};

export default useSetActiveRoleMutation;
